export default __webpack_public_path__ + "static/media/img.13b798d6.jpg";